export const FETCH_LANGUAGES_REQUEST =
  'app/TTS_LANGUAGES/FETCH_LANGUAGES_REQUEST';
export const FETCH_LANGUAGES_SUCCESS =
  'app/TTS_LANGUAGES/FETCH_LANGUAGES_SUCCESS';
export const FETCH_LANGUAGES_ERROR = 'app/TTS_LANGUAGES/FETCH_LANGUAGES_ERROR';

export const FETCH_LANGUAGE_VOICES_REQUEST =
  'app/TTS_LANGUAGES/FETCH_LANGUAGE_VOICES_REQUEST';
export const FETCH_LANGUAGE_VOICES_SUCCESS =
  'app/TTS_LANGUAGES/FETCH_LANGUAGE_VOICES_SUCCESS';
export const FETCH_LANGUAGE_VOICES_ERROR =
  'app/TTS_LANGUAGES/FETCH_LANGUAGE_VOICES_ERROR';
